import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { Conta } from '@app/models/conta.model';
import { ContaService } from '@app/services/conta.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-conta-lista',
  templateUrl: './conta-lista.component.html'
})

export class ContaListaComponent implements OnInit {

  lstConta: Conta[];
  paginacao: Paginacao;
  filtroDescricao: string = '';
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private contaService: ContaService,
    private modalService: BsModalService
  ) {
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.contaService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstConta = data.Dados,
        this.paginacao.totalDeItens = data.Total
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(conta: Conta) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir a conta: ' + conta.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.contaService.deletar(conta.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
